import script from "./EditAccount.vue?vue&type=script&setup=true&lang=js"
export * from "./EditAccount.vue?vue&type=script&setup=true&lang=js"

import "./EditAccount.vue?vue&type=style&index=0&id=43dedaa2&scoped=true&lang=css"

import exportComponent from "/home/interact/webapp/4.frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43dedaa2"]])

export default __exports__